// About Localizacao Page JavaScript

import changeCities from "../modules/Utils/changeCities";
changeCities();
document.addEventListener('DOMContentLoaded', function() {
    console.log('About Localizacao page loaded');

    // Initialize page functionality
    initAboutLocalizacaoPage();

    // Initialize map functionality
    initializeMap();
});

function initAboutLocalizacaoPage() {
    // Add any specific functionality for the About Localizacao page here

    // Example: Smooth scrolling for navigation links
    const navLinks = document.querySelectorAll('.about-hero__nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Add smooth scrolling or other navigation functionality
            console.log('Navigation link clicked:', this.textContent);
        });
    });

    // Example: Animate content on scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe content sections for animation
    const contentSections = document.querySelectorAll('.about-content__text');
    contentSections.forEach(section => {
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(section);
    });
}

function initializeMap() {
    // Get coordinates and address from hidden inputs
    const latitude = document.getElementById('lat').value;
    const longitude = document.getElementById('lng').value;
    const addressLink = document.getElementById('addressLink').value;

    const popupPositions = [
        0,
        screen.width > 992 ? -110 : -30
    ];

    // Create map with specified coordinates
    const map = L.map('mapa', {
        closePopupOnClick: false
    }).setView([latitude, longitude], 14);

    // Disable mouse scroll
    map.scrollWheelZoom.disable();

    // Create map layer
    const layer = new L.TileLayer(
       "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 16
        }
    );
    // Add layer to map
    map.addLayer(layer);

    // Custom icon configuration
    const customIcon = {
       iconUrl: document.getElementById('map-icon').value,
       iconSize: [65, 88],
       popupAnchor: [popupPositions[0], popupPositions[1]],
       setZIndex: 10,
    };
    const myIcon = L.icon(customIcon);

    const iconOptions = {
       title: 'RodoTécnica',
       draggable: false,
       icon: myIcon,
    };

    // Create marker
    const marker = new L.Marker([latitude, longitude], iconOptions);
    const address = document.getElementById('address').value;
    marker.addTo(map);

    // Bind popup with options
    marker.bindPopup(`<p>
        <a href="${addressLink}" target="_blank" aria-label="navegar para mapa">
            ${address}
        </a>
    </p>`, {
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        keepInView: true
    }).openPopup();

    // Prevent popup from closing
    marker.on('click', function () {
        marker.openPopup();
    });

    const mapa = document.querySelector('#mapa');
}
